import Vue from "vue";
const vm = Vue.prototype;

// Key must match AppSettingService.KEY_EXCEL_EXPORT_DISABLED on the backend.
export const EXCEL_EXPORT_DISABLED = "EXCEL_EXPORT_DISABLED";

export const state = () => ({
  settings: [],
});

export const mutations = {
  SET_APP_SETTINGS(state, payload) {
    state.settings = vm.$toArray(payload);
  },
};

export const actions = {
  async INIT_APP_SETTINGS({ commit }) {
    const data = await vm.$axios.$get("admin/app-settings");
    if (data) commit("SET_APP_SETTINGS", data);
    return data;
  },

  async UPDATE_APP_SETTING(_, { key, enabled }) {
    return await vm.$axios.$put(`admin/app-settings/${key}`, { enabled });
  },
};

export const getters = {
  GET_APP_SETTINGS: (state) => state.settings,

  GET_EXCEL_EXPORT_DISABLED: (state) =>
    state.settings.some((s) => s.settingKey === EXCEL_EXPORT_DISABLED && s.enabled === true),
};
